import { cn } from "@/lib/utils";
import { type ComponentProps, mergeProps, splitProps } from "solid-js";

export default function HumanitixIframe(
  props: ComponentProps<"iframe"> & {
    readonly collection?: string;
  },
) {
  const merged = mergeProps(
    {
      collection: "positive-traction-workshops",
    },
    props,
  );

  const [local, rest] = splitProps(merged, ["class", "collection"]);

  return (
    <>
      <script src="https://events.humanitix.com/scripts/widgets/inline.js" type="module" />
      <iframe
        data-collection={local.collection}
        title="Positive Traction Workshop"
        class={cn(local.class)}
        {...rest}
      />
    </>
  );
}
